import styled from 'styled-components';
import PlantingProjectSearch from '../containers/PlantingProjectSearch/PlantingProjectSearch';
import {ActionContainer, ActionList} from '../components/Buttons/SaveChanges';
import {UserRoles} from '../providers/UserProvider';
import {AddProjectMenu} from '../components/AddProjectMenu/AddProjectMenu';

const PositionedActionContainer = styled(ActionContainer)`
    position: absolute;
    top: 3.6rem;
    right: 2rem;
`;

function Proposals() {
    return (
        <>
            <PlantingProjectSearch proposalMode={true} />
            {UserRoles().includes('editor') && (
                <PositionedActionContainer>
                    <ActionList>
                        <AddProjectMenu proposalMode={true} />
                    </ActionList>
                </PositionedActionContainer>
            )}
        </>
    );
}

export default Proposals;
